import React, { FC } from 'react';

import { EmailRequired, PasswordRequired } from '@core/constants/validationSchemaText';
import { RequestStatus } from '@core/enums/request-status.enum';
import { AuthTokenModel } from '@core/models/auth.model';
import { loginThunk, toggleForgetPasswordModal } from '@redux/features/login.slice';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import ButtonLoader from 'components/ui/buttons/ButtonLoader';
import ButtonText from 'components/ui/buttons/ButtonText';
import InputError from 'components/ui/form/InputError';
import InputLabel from 'components/ui/form/InputLabel';
import { useFormik as useFormic } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';
import Cookies from 'js-cookie';
import { TOKEN_INFO } from '@core/constants/generic.constant';
import { useNavigate } from 'react-router-dom';
import { PRIVATEPATHS } from '@core/enums/paths.enum';

interface IProps {
    setUserToken: (userToken: AuthTokenModel) => void;
}

const LoginForm: FC<IProps> = ({ setUserToken }) => {
    // -------------------------------------------------------------------------------------
    const loading = useAppSelector((state: RootState) => state.authState.loading);
    const token = useAppSelector((state: RootState) => state.authState.token);

    //------------------------------------------------------------------------------------
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    //------------------------------------------------------------------------------------
    const handleSubmit = (values: any) => {
        dispatch(loginThunk(values)).then((res: any) => {
            if (res.meta.requestStatus === RequestStatus.FULFILLED) {
                Cookies.set(TOKEN_INFO, JSON.stringify(res.payload.token), {
                    secure: true,
                    sameSite: `strict`,
                    path: `/`,
                });
                navigate(PRIVATEPATHS.Dashboard);
            }
        });
    };
    // -------------------------------------------------------------------------------------
    const validation: any = useFormic({
        enableReinitialize: true,
        initialValues: {
            email: ``,
            pass: ``,
        },
        validationSchema: Yup.object({
            email: Yup.string().required(EmailRequired),
            pass: Yup.string().required(PasswordRequired),
        }),
        onSubmit: handleSubmit,
    });
    // -------------------------------------------------------------------------------------
    return (
        <form>
            {/* <div className="mt-5 text-center">
                <h4 className="text-custom-500 font-extrabold">Antar Dashboard Login</h4>
            </div> */}
            <div className="mb-5">
                <InputLabel htmlFor={`email`} innerText={`Email`} />
                <input
                    type="text"
                    id="email"
                    name="email"
                    className="input-style"
                    placeholder="Enter email"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email || ``}
                    onKeyDown={(e) => {
                        if (e.key === `Enter`) document?.getElementById(`confirm-btn`)?.click();
                    }}
                />
                <InputError
                    hasError={validation.touched.email && validation.errors.email}
                    errorText={validation.errors.email}
                    id={`email-error`}
                />
            </div>
            <div className="mb-5">
                <InputLabel htmlFor={`password`} innerText={`Password`} />
                <input
                    type="password"
                    id="password"
                    name="pass"
                    className="input-style"
                    placeholder="Enter password"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.pass || ``}
                    onKeyDown={(e) => {
                        if (e.key === `Enter`) document?.getElementById(`confirm-btn`)?.click();
                    }}
                />
                <InputError
                    hasError={validation.touched.pass && validation.errors.pass}
                    errorText={validation.errors.pass}
                    id={`password-error`}
                />
            </div>
            <div className="mt-5">
                <ButtonLoader
                    innerText={`Sign In`}
                    isLoading={loading}
                    onClick={validation.handleSubmit}
                    id={`confirm-btn`}
                />
            </div>
            {/* <div className="mt-5 flex items-center justify-end gap-1 text-center text-xs">
                <span className="text-slate-100 dark:text-zink-200">{`Forgot password?`}</span>
                <ButtonText
                    innerText={`Click here`}
                    onClick={() => dispatch(toggleForgetPasswordModal(true))}
                    disabled={loading}
                />
            </div> */}
        </form>
    );
};

export default LoginForm;
